/** Platform /v1/models 用户组有效价格；这里只展示积分，不推算实际账单。 */
export interface ModelCreditPricing {
  mode: 'per_token' | 'per_call' | 'free';
  billing_mode: 'off' | 'shadow' | 'live';
  input_per_1k: number;
  output_per_1k: number;
  per_call: number;
  relative_ratio: number;
}

/** 严格读取价目白名单；Go DTO 的 omitempty 数值缺省为零，无效值和未定价不显示免费。 */
export function parseModelCreditPricing(value: unknown): ModelCreditPricing | undefined {
  if (!value || typeof value !== 'object') return undefined;
  const p = value as Record<string, unknown>;
  if (!['per_token', 'per_call', 'free'].includes(String(p.mode)) || !['off', 'shadow', 'live'].includes(String(p.billing_mode))) return undefined;
  const keys = ['input_per_1k', 'output_per_1k', 'per_call', 'relative_ratio'] as const;
  if (keys.some(k => p[k] !== undefined && (typeof p[k] !== 'number' || !Number.isFinite(p[k]) || (p[k] as number) < 0))) return undefined;
  return { mode: p.mode as ModelCreditPricing['mode'], billing_mode: p.billing_mode as ModelCreditPricing['billing_mode'],
    input_per_1k: (p.input_per_1k as number) ?? 0, output_per_1k: (p.output_per_1k as number) ?? 0,
    per_call: (p.per_call as number) ?? 0, relative_ratio: (p.relative_ratio as number) ?? 0 };
}

/** 使用调用方国际化文案生成完整计价单位，缺价格或关闭积分时返回空。 */
export function modelCreditPriceText(pricing: ModelCreditPricing | undefined, t: (key: string) => string): string | null {
  if (!pricing || pricing.billing_mode === 'off') return null;
  const fmt = (value: number) => new Intl.NumberFormat(undefined, { maximumFractionDigits: 4 }).format(value);
  const detail = pricing.mode === 'free' ? t('creditFree') : pricing.mode === 'per_call'
    ? `${fmt(pricing.per_call)} ${t('creditPerCall')}`
    : `${t('creditInput')} ${fmt(pricing.input_per_1k)} · ${t('creditOutput')} ${fmt(pricing.output_per_1k)} ${t('creditPer1k')}`;
  return detail + (pricing.billing_mode === 'shadow' ? ` · ${t('creditShadowShort')}` : '');
}
